

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = obj => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')

// ** Checks if the passed date is today
const isToday = date => {
    const today = new Date()
    return (
        /* eslint-disable operator-linebreak */
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
        /* eslint-enable */
    )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
    if (!value) return value
    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
    const date = new Date(value)
    let formatting = { month: 'short', day: 'numeric' }

    if (toTimeForCurrentDay && isToday(date)) {
        formatting = { hour: 'numeric', minute: 'numeric' }
    }

    return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem('userData')
export const getUserData = () => JSON.parse(localStorage.getItem('userData'))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
    if (userRole === 'admin') return '/'
    if (userRole === 'client') return '/access-control'
    return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
    ...theme,
    colors: {
        ...theme.colors,
        primary25: '#7367f01a', // for option hover bg-color
        primary: '#0c72fe', // for selected option bg-color
        neutral10: '#0c72fe', // for tags bg-color
        neutral20: '#ededed', // for input border-color
        neutral30: '#ededed' // for input hover border-color
    }
})

export const signOutClearStorage = (client) => {
    localStorage.clear();
    sessionStorage.clear();
    client.cache.reset();
}

export const getTranslation = (key, intlContext) => {
    let translated;

    switch (key) {
        case "Formula":
        case "Formule":
            translated = intlContext?.messages?.["Formula"];
            break;

        case "Variabele":
        case "Variable":
            translated = intlContext?.messages?.["Variable"];
            break;

        case "Unity check":
            translated = intlContext?.messages?.["UnityCheck"];
            break;

        case "Conclusie":
        case "Conclusion":
            translated = intlContext?.messages?.["Conclusion"];
            break;

        case "Tekst":
        case "Text":
            translated = intlContext?.messages?.["Text"];
            break;

        case "Afbeelding":
        case "Image":
            translated = intlContext?.messages?.["Image"];
            break;

        case "Materialen":
        case "Material Information":
            translated = intlContext?.messages?.["Material"];
            break;

        case "Belasting tabel":
        case "Load table":
            translated = intlContext?.messages?.["LoadTable"];
            break;

        case "Pulldown":
            translated = intlContext?.messages?.["Pulldown"];
            break;

        case "Gebruikers invoer":
        case "User input":
            translated = intlContext?.messages?.["UserInput"];
            break;

        case "Zoek in tabel":
        case "Lookup":
            translated = intlContext?.messages?.["Lookup"];
            break;

        case "Tabel":
        case "Table":
            translated = intlContext?.messages?.["Table"];
            break;

        case "Sub sectie":
        case "Sub section":
            translated = intlContext?.messages?.["SubSection"];
            break;

        default:
            translated = intlContext?.messages?.[key];
            break;
    }

    const translatedLower = typeof translated === "string" ? translated.toLowerCase() : key.toLowerCase();

    return `${intlContext?.messages?.Selected} ${translatedLower} ${intlContext?.messages?.WillBeAddedHere}`;
};
